module.exports = "/_next/static/images/261f4810687239c344e31039a3ad78d0-man-with-cellphone-xs@1x.jpg";